/**
 * Created by jonas on 2023-01-12.
 */
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {BS2} from "../BS2";
import {
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {LocalPresentation} from "../../core/winpresentation/LocalPresentation";
import {FreeSpinUtils} from "../utils/FreeSpinUtils";
import {FreesSpinIntro} from "../runnerpresentations/FreesSpinIntro";

export class BS2ZeroBetPresentation {

    constructor() {
    }

    start(flowStateController: FlowStateController): void {

        const presentations = [
            new FreesSpinIntro(),
            new LocalPresentation((controller: SimplePresentationRunnerController) => this.doZeroBet(controller), () => {
                return true
            }, "doZeroBet"),
        ]
        SimplePresentationRunner.run(presentations, () => flowStateController.finish(), (callback?: Function) => flowStateController.setSkipCallback(callback), "WinRunner ");
    }

    private doZeroBet(controller: SimplePresentationRunnerController) {
        BS2.normalBet.makeBetDoneAndStartDoneFalse();
        SlotGame.apiPlugin.betHandler.zeroBet();

        if (BS2.model.isNextFreeSpin() || BS2.model.isNextSuperFreespin()) {
            if (BS2.model.data.nextMode.indexOf("AVALANCHE") > -1) {
                BS2.reelView.hideAllRemainingScatters();
                FreeSpinUtils.setKeypadSpinCounter(BS2.model.data.freespinsLeft);
                BS2.reelView.freespinCounter.showCount(BS2.model.data.freespinsLeft);
            } else {
                BS2.keypadPlugin.setZeroBetSpinCounter(BS2.model.data.freespinsLeft - 1);
                BS2.reelView.freespinCounter.showCount(BS2.model.data.freespinsLeft - 1);
            }

        }
        controller.finish();
    }
}